import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect, useSelector, useDispatch } from "react-redux";
import { fetchUserInfo, updateUserInfo, setUserInfoLocal } from "../../../redux/actions/userActions";
import { fetchOrganizationInfo } from "../../../redux/actions/organizationActions";

const getDisabled = (value) => {
  switch (value) {
    case "Rôle":
      return true;

    case "Nom":
      return false;

    case "Prénom":
      return false;

    case "Email":
      return true;

    case "Organization":
      return true;

    case "position":
      return false;

    default:
      return "";
  }
};
const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div className="flex justify-start items-center">
    <div className="w-[140px] h-[50px] flex items-center">
      <label className="text-sm font-Poppins-Light">{label}</label>
    </div>
    <div className="h-full flex items-center">
      <input
        disabled={getDisabled(label)}
        {...input}
        placeholder={label}
        type={type}
        className={"w-[300px] bg-[#F3F5F7] h-[35px] rounded-lg pl-[10px] text-xs font-Poppins-Regular " + (getDisabled(label) ? "text-gray-400" : "")}
      />
    </div>
  </div>
);

const validate = (val) => {
  const errors = {};
  if (!val.firstName) {
    console.log("First Name is required");
    errors.firstName = "Required";
  }
  if (!val.lastName) {
    console.log("Last Name is required");
    errors.lastName = "Required";
  }
  if (!val.email) {
    console.log("email is required");
    errors.email = "Required";
  } else if (!/^.+@.+$/i.test(val.email)) {
    console.log("email is invalid");
    errors.email = "Invalid email address";
  }
  if (!val.age) {
    errors.age = "Required";
  } else if (isNaN(Number(val.age))) {
    errors.age = "Must be a number";
  } else if (Number(val.age) < 18) {
    errors.age = "Sorry, you must be at least 18 years old";
  }
  return errors;
};

let ContactForm = (props) => {
  const { handleSubmit, input } = props;
  const [changed, setChanged] = useState(false);
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field name="role" component={renderField} type="text" label="Rôle" />
      </div>
      <div>
        <Field name="name" onChange={(e) => setChanged(true)} component={renderField} type="text" label="Nom" />
      </div>
      <div>
        <Field name="lastname" onChange={(e) => setChanged(true)} component={renderField} type="text" label="Prénom" />
      </div>
      <div>
        <Field name="email" component={renderField} type="text" label="Email" />
      </div>
      <div>
        <Field name="organization_name" onChange={(e) => setChanged(true)} component={renderField} type="text" label="Organisation" />
      </div>
      <div>
        <Field name="position" onChange={(e) => setChanged(true)} component={renderField} type="text" label="Position" />
      </div>
      {/* <button type="submit">Submit</button> */}

      <div className="w-full h-[80px] flex items-center justify-center">
        {changed === false ? (
          <button disabled className="font-Poppins-SemiBold text-gray-400 text-sm bg-[#F3F5F7] w-[180px] h-[40px] rounded-lg">
            Valider
          </button>
        ) : (
          <button type="submit" className="font-Poppins-SemiBold text-white text-sm bg-mainGreen w-[180px] h-[40px] rounded-lg">
            Valider
          </button>
        )}
      </div>
    </form>
  );
};

ContactForm = reduxForm({
  // a unique name for the form
  form: "contact",
})(ContactForm);

// export default ContactForm

export default connect((state) => ({
  // alternatively, you can set initial values here...
  initialValues: {
    role: state.user.user_info ? state.user.user_info.organization_info.role.name : "",
    name: state.user.user_info ? state.user.user_info.user_info.name : "",
    lastname: state.user.user_info ? state.user.user_info.user_info.lastname : "",
    email: state.user.user_info ? state.user.user_info.user_info.email : "",
    organization_name: state.user.user_info ? state.user.user_info.organization_info.name : "",
    // organization_name: state.organization.organization_info ? state.organization.organization_info.organization_info.name : '',
    position: state.user.user_info ? state.user.user_info.organization_info.position : "",
  },
  enableReinitialize: true,
}))(ContactForm);
